<template>
  <div
    class="hkl-external-link-icon"
    :class="{ 'hkl-external-link-icon--disabled': disabled }"
  >
    <i
      v-bind="$attrs"
      :class="['fa', 'fa-external-link', { pointer: !disabled }]"
      v-on="disabled ? {} : $listeners"
    />
  </div>
</template>
<script>
export default {
  name: 'HKLExternalLinkIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.hkl-external-link-icon {
  color: var(--default-color);

  &--disabled {
    color: #9e9e9e;
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
